import React, { useState, useEffect } from 'react';

export default function ProfileNotesLogs({ userId, indId, userAccessToken }) {
  const [messages, setMessages] = useState(null);
  const [messagesLoading, setMessagesLoading] = useState(true);

  const [messagesPage, setMessagesPage] = useState(null);
  const [messagesPages, setMessagesPages] = useState([]);
  const [messagesLimit] = useState(10);
  const [messagesOffset, setMessagesOffset] = useState(0);

  var webAPI = new MedicareProAPI.WebAPI();
  webAPI.setAccessToken(userAccessToken);

  var userLogRepository = new MedicareProAPI.UserLogRepository();
  userLogRepository.setAccessToken(userAccessToken);

  const handleChangePage = (newPage) => {
    setMessagesPage(newPage);
    setMessagesOffset((newPage - 1) * messagesLimit);
  };

  const options = { limit: messagesLimit, offset: messagesOffset, criteria: { indId: indId } };
  useEffect(() => {
    userLogRepository.getUserLogs(userId, options).then((response) => {
      setMessagesLoading(false);
      setMessages(response);

      let totalPages = Math.ceil(response.getTotal() / messagesLimit);
      let pages = [];

      while (totalPages > 0) {
        pages.push({
          label: totalPages,
          value: totalPages,
        });

        totalPages--;
      }

      pages.reverse();

      setMessagesPages(pages);
    });
  }, [messagesOffset]);

  return (
    <div className="row sms-log pt-2">
      {messagesLoading && (
        <div className="col-12">
          <div className="alert small alert-info" role="alert">
            <i className="fas fa-spinner fa-spin ml-2"></i> Loading....
          </div>
        </div>
      )}
      {messages &&
        messages.getTotal() > 0 &&
        messages.getItems().map((data) => {
          var theDate = new Date(data.dateTimeCreated.date.replace(' ', 'T') + 'Z');
          var day = theDate.getDate();
          var month = theDate.getMonth() + 1;
          var year = theDate.getFullYear();
          var hour = theDate.getHours().toString().padStart(2, 0);
          var minutes = theDate.getMinutes().toString().padStart(2, 0);
          var amPm = hour >= 12 ? 'pm' : 'am';
          var standardHour = hour >= 13 ? hour - 12 : hour;
          var theDateFinal =
            month + '/' + day + '/' + year + ' @ ' + standardHour + ':' + minutes + ' ' + amPm;

          let classList = [
            'float-right',
            'badge',
            'badge-' + (data.direction == 'S' ? 'info' : 'success'),
          ];

          return (
            <div class="col-12 small">
              <div class="border-bottom p-2 cp">
                <strong>
                  <em class="far fa-chart-network text-info mr-2"></em>
                  {theDateFinal}
                </strong>{' '}
                - {data.type}
                <div className="mt-1" style={{ whiteSpace: 'pre' }}>
                  {data.data}
                </div>
              </div>
            </div>
          );
        })}
      {messages && messages.getTotal() > 0 && messagesPages && messagesPages.length > 1 && (
        <div className="col-12 mt-1">
          <span class="small d-inline-block mr-1">Page:</span>
          <select
            onChange={(e) => handleChangePage(parseInt(e.target.value))}
            className="form-control-sm border-secondary d-inline-block"
          >
            {messagesPages.map((messagesPageSingle) => {
              return (
                <option
                  selected={messagesPageSingle.value === messagesPage}
                  value={messagesPageSingle.value}
                >
                  {messagesPageSingle.label}
                </option>
              );
            })}
          </select>
          <span class="small d-inline-block ml-1">of {messagesPages.length}</span>
        </div>
      )}
      {messages && messages.getTotal() === 0 && (
        <div className="col-12">
          <div className="alert small alert-info" role="alert">
            No logs to show.
          </div>
        </div>
      )}
    </div>
  );
}
